/**
 * Copyright © 2025-2026 Delicious AI, LLC
 */

import styled from '@emotion/styled'
import {
  Grid2 as Grid,
  List,
  ListItemButton as MuiListItemButton,
  ListItemButtonProps as MuiListItemButtonProps,
  ListItemText as MuiListItemText,
} from '@mui/material'

interface ListItemButtonProps extends MuiListItemButtonProps {
  href?: string
  target?: string
}

const Wrapper = styled.div`
  padding: 0 ${props => props.theme.spacing(2)};
  background: ${props => props.theme.footer.background};
  position: relative;
  min-height: 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const ListItemButton = styled(MuiListItemButton)<ListItemButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-height: 0;
  height: 28px;
  padding: 0 ${props => props.theme.spacing(1)};

  &,
  &:hover,
  &:active {
    color: ${props => props.theme.footer.color};
  }
`

const ListItemText = styled(MuiListItemText)`
  display: flex;
  align-items: center;
  margin: 0;

  span {
    color: ${props => props.theme.footer.color};
    font-size: 0.75rem;
    line-height: 1.2;
  }
`

function Footer() {
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          container
          justifyContent="flex-end"
          size={{
            xs: 12,
          }}
        >
          <List sx={{ py: 0 }}>
            <li>
              <ListItemButton
                href="https://deliciousai.com"
                component={'a'}
                rel="noopener noreferrer"
                target="_blank"
              >
                <ListItemText
                  primary={`© ${new Date().getFullYear()} Delicious AI`}
                />
              </ListItemButton>
            </li>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  )
}

export default Footer
